import React from 'react';
import { ClientItem, Item } from '../../model/item/ItemTypes';
import { Option } from '../../model/Interface';
import General from './GeneralInfo';
import { tactin } from '../../utils/TactinGlobals';
import ListSubPanel from './ListSubPanel';
import { ActionContextProvider } from '../../model/systemactions/ActionContext';
import { Notification } from '../systemactions/SystemAction';
import SeriesConfigTemp from './SeriesConfigTemp';
import ElementList from './ElementList';
import UIFactory from '../core/UIFactory';
import { UserAddOnPanel } from './useraddon/UserAddOnPanel';
import { SimplifiedSeriesPanel } from './series/SimplifiedSeriesPanel';
import { CardSubPanelWrapper } from './CardSubPanelWrapper';
import MainAnalysis from '../../cngr/components/analytics/MainAnalysis';
import MainAnalysisDetails from '../../cngr/components/analytics/MainAnalysisDetails';
import { ToolbarOption } from './ItemToolbar';
import FinancialInstrumentView from '../../cngr/components/ui/FinancialInstrumentView';
import PreviewInfo from './PreviewInfo';

type SubPanelProps = {
    option: Option;
    original: ClientItem;
    item: ClientItem;
    onChange: (item: Item) => void;
    contextProvider?: ActionContextProvider;
    notifyHandler?: (note: Notification) => void;
    className?: string;
    onExternalToolbarAction: (action: ToolbarOption) => Promise<void>
    setToolbarVisibility: (visible: boolean) => void;
    onCloseRequest?: () => void;
}

export default function SubPanel(props: SubPanelProps) {
    const primaryConfig = props.option.handlerConfiguration || {}
    const standardConfig = tactin().standardHandler(props.option.handlerClass) || {};
    const config = {
        ...standardConfig,
        ...primaryConfig
    };

    const canEdit = () => {
        return props.item.permission.toLowerCase() === 'delete' || props.item.permission.toLowerCase() === 'edit';
    }

    props.setToolbarVisibility(canEdit());

    switch (props.option.handlerClass) {
        case 'General':
        case 'KnowledgeBaseArticle':
        case 'HelpArticle':
            return <General
                itemData={props.item}
                configuration={config}
                columnConfig={[
                    standardConfig.columns || [],
                    primaryConfig.columns || []
                ]}
                onChange={props.onChange}
                contextProvider={props.contextProvider}
                notifyHandler={props.notifyHandler} />;
        case 'PreviewInfo':
            props.setToolbarVisibility(false);
            return <PreviewInfo
                itemData={props.item} />
        case 'ListSubPanel':
            return <ListSubPanel
                itemData={props.item}
                configuration={config} />
        case 'ElementListSubPanel':
            return <ElementList
                itemData={props.item}
                configuration={config}
                onChange={props.onChange}
                contextProvider={props.contextProvider}
                notifyHandler={props.notifyHandler} />;
        case 'UserSubPanel':
            return <UserAddOnPanel
                original={props.original}
                itemData={props.item}
                configuration={config}
                onChange={props.onChange} />
        case 'MainAnalysis':
            props.setToolbarVisibility(false);
            return <MainAnalysis
                clientItem={props.item}
                onChange={props.onChange}
                itemSaveAction={props.onExternalToolbarAction}
                closeAnalysisWindow={props.onCloseRequest} />
        case 'FinancialInstrumentView':
            return <FinancialInstrumentView
                itemData={props.item}
                configuration={config}
                columnConfig={[
                    standardConfig.columns || [],
                    primaryConfig.columns || []
                ]}
                onChange={props.onChange}
                contextProvider={props.contextProvider}
                notifyHandler={props.notifyHandler} />;
        case 'modifiedFieldConfig':
            return <SeriesConfigTemp itemData={props.item} field='modifyConfig' onChange={props.onChange} />
        case 'generationConditionConfig':
            return <SeriesConfigTemp itemData={props.item} field='generationConfig' onChange={props.onChange} />
        case 'realizationConditionConfig':
            return <SeriesConfigTemp itemData={props.item} field='realizationConfig' onChange={props.onChange} />
        case "simplifiedSeries":
            return <SimplifiedSeriesPanel original={props.original} itemData={props.item} configuration={config} onChange={props.onChange} />;
        default:
            return <CardSubPanelWrapper configuration={config}>
                {UIFactory.getViewerPanel(props.option.handlerClass, primaryConfig, standardConfig, props.item.item.itemID).main}
            </CardSubPanelWrapper>
    }
}
